
let hasWebAuthFunnelEnabled: boolean | undefined;

const isWebAuthFunnelEnabled = (() => {
    if (hasWebAuthFunnelEnabled !== undefined) {
        return hasWebAuthFunnelEnabled
    }
    try {
        hasWebAuthFunnelEnabled = window.dazn.features.isEnabledAnonymous(
            'f_ar_web_funnel_tracking',
        );
        return hasWebAuthFunnelEnabled;
    } catch (_err) {
        return false;
    }
})()

export {isWebAuthFunnelEnabled};
